const scopes = {
    rateSheet: "rsheet",
    wallets: "wltmgmt",
    packages: "pckg",
    senderAddress: "snd_adr",
    emailAddress: "email_adr",
    senderAddressSpec: "snd_adr_spec",
    shortCodes: "shortcodes",
    accounts: "acmgmt",
    workflow: "wrkfl",
    invoice: "inv",
    users: "usr",
    roles: "rlc",
    campaignManagement: "cmpgmgmt",
    emailcampaign: "email_cmpg",
    smsTemplates: "smstmp",
    emailTemplates: "emailtmp",
    contactManagement: "cntmgmt",
    profile: "profile",
    email: "email",
    revenueReport: "rvnrpt",
    pushAndPullReport: "pprpt",
    Inventory: "invt",
    assignNumbers: "anum",
    moService: "mosvc",
    numberList: "numls",
    activityLog: "alog",
    enterpriseLog: "elog",
    debuglog: "debugLog",
    configureNumbers: "cfgnum",
    groupManagement: "grpmgmt",
    configureIvr: "cfgivr",
    sipManagement: "sipmgmt",
    segment: "segment",
    providers: "providers",
    routing: "routing",
    blacklist: "blacklist",
    dnd: "dnd",
    alerts: "alert",
    emailConfiguration: "email_cfg",
    studio: "studio",
    agt_stg: "agentSettings",
    agents: "agnt",
    dpmt: "departments",
    chats: "chats",
    wa_tmp_share: "wa_tmp_share",
    apidoc: "apidoc",
};
const permissions = {
    create: "c",
    read: "r",
    transfer: "t",
    edit: "e",
    delete: "d",
    buy: "b",
    download: "dw",
    approve: "a",
    reject: "rj",
    statusUpdate: "su",
};
const npermissions = {
    c: "create",
    r: "read",
    t: "transfer",
    e: "edit",
    d: "delete",
    b: "buy",
    dw: "download",
    a: "approve",
    rj: "reject",
    su: "statusUpdate",
};
const nscopes = {
    rsheet: "rateSheet",
    wltmgmt: "wallets",
    pckg: "packages",
    snd_adr: "senderAddress",
    email_adr: "emailAddress",
    snd_adr_spec: "senderAddressSpec",
    //sndrid: "senderId",
    shortcodes: "shortCodes",
    acmgmt: "accounts",
    wrkfl: "workflow",
    inv: "invoice",
    usr: "users",
    rlc: "roles",
    sms_cmpg: "campaignManagement",
    email_cmpg: "emailcampaign",
    smstmp: "smsTemplates",
    emailtmp: "emailTemplates",
    cntmgmt: "contactManagement",
    profile: "profile",
    email: "email",
    invt: "Inventory",
    anum: "assignNumbers",
    mosvc: "moService",
    numls: "numberList",
    dlog: "debugLog",
    alog: "activityLog",
    elog: "enterpriseLog",
    dshb: "dashboard",
    rpt: "reports",
    smpp: "smpp",
    vc_cmpg: "voiceCampaign",
    vc_flmgr: "voiceFileManager",
    cfgnum: "configureNumbers",
    cfgivr: "configureIvr",
    vr_flmgr: "vrFileManager",
    wa_tmp: "whatsappTemplates",
    wa_cmpg: "whatsappCampaigns",
    sdbx: "sandbox",
    txnhis: "transactionHistory",
    apiky: "apikey",
    hme: "home",
    apidoc: "apidoc",
    grpmgmt: "groupManagement",
    sipmgmt: "sipManagement",
    segment: "segment",
    providers: "providers",
    routing: "routing",
    blacklist: "blacklist",
    dnd: "dnd",
    alert: "alerts",
    email_cfg: "emailConfiguration",
    studio: "studio",
    agentSettings: "agt_stg",
    agnt: "agents",
    departments: "dpmt",
    chats: "chats",
    wa_tmp_share: "wa_tmp_share",
    content_filter: "contentFilter",
    rcs_cmpg: "rcsCampaign",
    quiet_time: "queitTime",
};
export function getScope(scopeName, permission) {
    if (scopes[scopeName] && permissions[permission])
        return scopes[scopeName] + "_" + permissions[permission];
    else
        return null;
}
export function createScopePermissions(scope) {
    let finalScope = {};
    if (scope) {
        let scopeArray = scope.split(" ");
        scopeArray.forEach((x) => {
            let i = x.lastIndexOf("_");
            let moduleName = nscopes[x.substring(0, i)];
            let newObj = {};
            let permission = npermissions[x.substring(i + 1)];
            newObj[permission] = true;
            if (finalScope[moduleName]) {
                finalScope[moduleName] = Object.assign(Object.assign({}, finalScope[moduleName]), newObj);
            }
            else {
                finalScope[moduleName] = newObj;
            }
        });
    }
    return finalScope;
}
//export default createScopePermissions;
